import {
  ENTITY_GROUP_CODE,
  PERMISSION_VALUE,
  SUMMARY_GROUP_CODE,
} from "src/configs/constant";

import {
  Combo as ComboIcon,
  Export as ExportIcon,
  Goods as GoodsIcon,
  GoodsBox as GoodsBoxIcon,
  Import as ImportIcon,
  Inventory as InventoryIcon,
  Material as MaterialIcon,
  Menu as MenuIcon,
  Permission as PermissionIcon,
  Solution as SolutionIcon,
  Summary as SummaryIcon,
  Supplier as SupplierIcon,
  WarehouseIcon,
} from "_assets/icons";

import {
  ChatLuongHangHoa,
  Combo,
  DeXuatNhaCungCap,
  Export,
  ExportKTT,
  HangHoa,
  Import,
  Inventory,
  Material,
  Menu,
  NhaCungCap,
  Permission,
  Solution,
  Summary,
  Warehouse,
} from "./constant";

const navigation = [
  //#region Báo cáo
  {
    _tag: "CSidebarNavDropdown",
    name: "Báo cáo",
    route: "/summary",
    icon: <SummaryIcon className="" />,
    permissions: {
      [SUMMARY_GROUP_CODE.ORDER]: PERMISSION_VALUE.READ,
      [SUMMARY_GROUP_CODE.IMPORT]: PERMISSION_VALUE.READ,
      [SUMMARY_GROUP_CODE.EXPORT]: PERMISSION_VALUE.READ,
      [SUMMARY_GROUP_CODE.CANCELLATION]: PERMISSION_VALUE.READ,
      [SUMMARY_GROUP_CODE.INVENTORY]: PERMISSION_VALUE.READ,
      [SUMMARY_GROUP_CODE.INVENTORY_ADJUSTMENT]: PERMISSION_VALUE.READ,
    },
    childrens: [
      Summary.Order.path,
      Summary.Export.path,
      Summary.ExportDetail.path,
      Summary.Import.path,
      Summary.ImportDetail.path,
      Summary.ExportRaw.path,
      Summary.ExportRawDetail.path,
      Summary.ImportRaw.path,
      Summary.ImportRawDetail.path,
      Summary.Transfer.path,
      Summary.Cancellation.path,
      Summary.CancellationDetail.path,
      Summary.Inventory.path,
      Summary.InventoryAdjustment.path,
    ],
    _children: [
      {
        _tag: "CSidebarNavItem",
        name: Summary.Order.name,
        to: Summary.Order.path,
        childrens: [Summary.Order.path],
        permissions: {
          [SUMMARY_GROUP_CODE.ORDER]: PERMISSION_VALUE.READ,
        },
      },
      {
        _tag: "CSidebarNavItem",
        name: Summary.Import.name,
        to: Summary.Import.path,
        childrens: [Summary.Import.path],
        permissions: {
          [SUMMARY_GROUP_CODE.IMPORT]: PERMISSION_VALUE.READ,
        },
      },
      {
        _tag: "CSidebarNavItem",
        name: Summary.ImportDetail.name,
        to: Summary.ImportDetail.path,
        childrens: [Summary.ImportDetail.path],
        permissions: {
          [SUMMARY_GROUP_CODE.IMPORT]: PERMISSION_VALUE.READ,
        },
      },
      {
        _tag: "CSidebarNavItem",
        name: Summary.Export.name,
        to: Summary.Export.path,
        childrens: [Summary.Export.path],
        permissions: {
          [SUMMARY_GROUP_CODE.EXPORT]: PERMISSION_VALUE.READ,
        },
      },
      {
        _tag: "CSidebarNavItem",
        name: Summary.ExportDetail.name,
        to: Summary.ExportDetail.path,
        childrens: [Summary.ExportDetail.path],
        permissions: {
          [SUMMARY_GROUP_CODE.EXPORT]: PERMISSION_VALUE.READ,
        },
      },
      {
        _tag: "CSidebarNavItem",
        name: Summary.ImportRaw.name,
        to: Summary.ImportRaw.path,
        childrens: [Summary.ImportRaw.path],
        permissions: {
          [SUMMARY_GROUP_CODE.IMPORT]: PERMISSION_VALUE.READ,
        },
      },
      {
        _tag: "CSidebarNavItem",
        name: Summary.ImportRawDetail.name,
        to: Summary.ImportRawDetail.path,
        childrens: [Summary.ImportRawDetail.path],
        permissions: {
          [SUMMARY_GROUP_CODE.IMPORT]: PERMISSION_VALUE.READ,
        },
      },
      {
        _tag: "CSidebarNavItem",
        name: Summary.ExportRaw.name,
        to: Summary.ExportRaw.path,
        childrens: [Summary.ExportRaw.path],
        permissions: {
          [SUMMARY_GROUP_CODE.EXPORT]: PERMISSION_VALUE.READ,
        },
      },
      {
        _tag: "CSidebarNavItem",
        name: Summary.ExportRawDetail.name,
        to: Summary.ExportRawDetail.path,
        childrens: [Summary.ExportRawDetail.path],
        permissions: {
          [SUMMARY_GROUP_CODE.EXPORT]: PERMISSION_VALUE.READ,
        },
      },
      {
        _tag: "CSidebarNavItem",
        name: Summary.Transfer.name,
        to: Summary.Transfer.path,
        childrens: [Summary.Transfer.path],
        permissions: {
          [SUMMARY_GROUP_CODE.IMPORT]: PERMISSION_VALUE.READ,
        },
      },
      {
        _tag: "CSidebarNavItem",
        name: Summary.Cancellation.name,
        to: Summary.Cancellation.path,
        childrens: [Summary.Cancellation.path],
        permissions: {
          [SUMMARY_GROUP_CODE.CANCELLATION]: PERMISSION_VALUE.READ,
        },
      },
      {
        _tag: "CSidebarNavItem",
        name: Summary.CancellationDetail.name,
        to: Summary.CancellationDetail.path,
        childrens: [Summary.CancellationDetail.path],
        permissions: {
          [SUMMARY_GROUP_CODE.CANCELLATION]: PERMISSION_VALUE.READ,
        },
      },
      {
        _tag: "CSidebarNavItem",
        name: Summary.Inventory.name,
        to: Summary.Inventory.path,
        childrens: [Summary.Inventory.path],
        permissions: {
          [SUMMARY_GROUP_CODE.INVENTORY]: PERMISSION_VALUE.READ,
        },
      },
      {
        _tag: "CSidebarNavItem",
        name: Summary.InventoryAdjustment.name,
        to: Summary.InventoryAdjustment.path,
        childrens: [Summary.InventoryAdjustment.path],
        permissions: {
          [SUMMARY_GROUP_CODE.INVENTORY_ADJUSTMENT]: PERMISSION_VALUE.READ,
        },
      },
    ],
  },
  //#endregion

  //#region Tồn kho
  {
    _tag: "CSidebarNavDropdown",
    name: "Tồn kho",
    route: "/inventory",
    icon: <InventoryIcon className="" />,
    permissions: {
      [ENTITY_GROUP_CODE.INVENTORY_SLIP]: PERMISSION_VALUE.READ,
      [ENTITY_GROUP_CODE.KIEM_KHO_CUOI_THANG]: PERMISSION_VALUE.READ,
      [ENTITY_GROUP_CODE.DINH_MUC_TON_KHO]: PERMISSION_VALUE.READ,
      [ENTITY_GROUP_CODE.BACKLOG_SLIP]: PERMISSION_VALUE.READ,
      [ENTITY_GROUP_CODE.INVENTORY_ADJUSTMENT]: PERMISSION_VALUE.READ,
      [ENTITY_GROUP_CODE.CANCEL_SLIP]: PERMISSION_VALUE.READ,
      [ENTITY_GROUP_CODE.RETURN_SLIP]: PERMISSION_VALUE.READ,
    },
    childrens: [
      Inventory.Check.List.path,
      Inventory.Check.Create.path,
      Inventory.Check.Update.path,
      Inventory.DinhMucTonKho.List.path,
      Inventory.Adjustment.List.path,
      Inventory.Slip.List.path,
      Inventory.Slip.Instant.path,
      Inventory.Return.List.path,
      Inventory.Return.Create.path,
      Inventory.Return.Update.path,
      Inventory.Cancel.List.path,
      Inventory.Cancel.Create.path,
      Inventory.Cancel.Update.path,
      Inventory.EndOfMonthCheck.List.path,
      Inventory.EndOfMonthCheck.Create.path,
      Inventory.EndOfMonthCheck.Update.path,
    ],
    _children: [
      {
        _tag: "CSidebarNavItem",
        name: Inventory.Check.List.name,
        to: Inventory.Check.List.path,
        childrens: [
          Inventory.Check.List.path,
          Inventory.Check.Create.path,
          Inventory.Check.Update.path,
        ],
        permissions: {
          [ENTITY_GROUP_CODE.INVENTORY_SLIP]: PERMISSION_VALUE.READ,
        },
      },
      {
        _tag: "CSidebarNavItem",
        name: Inventory.EndOfMonthCheck.List.name,
        to: Inventory.EndOfMonthCheck.List.path,
        childrens: [
          Inventory.EndOfMonthCheck.List.path,
          Inventory.EndOfMonthCheck.Create.path,
          Inventory.EndOfMonthCheck.Update.path,
        ],
        permissions: {
          [ENTITY_GROUP_CODE.KIEM_KHO_CUOI_THANG]: PERMISSION_VALUE.READ,
        },
      },
      {
        _tag: "CSidebarNavItem",
        name: Inventory.DinhMucTonKho.List.name,
        to: Inventory.DinhMucTonKho.List.path,
        childrens: [Inventory.DinhMucTonKho.List.path],
        permissions: {
          [ENTITY_GROUP_CODE.DINH_MUC_TON_KHO]: PERMISSION_VALUE.READ,
        },
      },
      {
        _tag: "CSidebarNavItem",
        name: Inventory.Slip.List.name,
        to: Inventory.Slip.List.path,
        childrens: [Inventory.Slip.List.path],
        permissions: {
          [ENTITY_GROUP_CODE.BACKLOG_SLIP]: PERMISSION_VALUE.READ,
        },
      },
      {
        _tag: "CSidebarNavItem",
        name: Inventory.Slip.Instant.name,
        to: Inventory.Slip.Instant.path,
        childrens: [Inventory.Slip.Instant.path],
        permissions: {
          [ENTITY_GROUP_CODE.BACKLOG_SLIP]: PERMISSION_VALUE.READ,
        },
      },
      {
        _tag: "CSidebarNavItem",
        name: Inventory.Adjustment.List.name,
        to: Inventory.Adjustment.List.path,
        childrens: [Inventory.Adjustment.List.path],
        permissions: {
          [ENTITY_GROUP_CODE.INVENTORY_ADJUSTMENT]: PERMISSION_VALUE.READ,
        },
      },
      {
        _tag: "CSidebarNavItem",
        name: Inventory.Return.List.name,
        to: Inventory.Return.List.path,
        childrens: [
          Inventory.Return.List.path,
          Inventory.Return.Create.path,
          Inventory.Return.Update.path,
        ],
        permissions: {
          [ENTITY_GROUP_CODE.RETURN_SLIP]: PERMISSION_VALUE.READ,
        },
      },
      {
        _tag: "CSidebarNavItem",
        name: Inventory.Cancel.List.name,
        to: Inventory.Cancel.List.path,
        childrens: [
          Inventory.Cancel.List.path,
          Inventory.Cancel.Create.path,
          Inventory.Cancel.Update.path,
        ],
        permissions: {
          [ENTITY_GROUP_CODE.CANCEL_SLIP]: PERMISSION_VALUE.READ,
        },
      },
    ],
  },
  //#endregion

  //#region Phiếu đề xuất
  {
    _tag: "CSidebarNavDropdown",
    name: "Phiếu đề xuất đặt hàng",
    route: "/solution",
    icon: <SolutionIcon className="" />,
    permissions: {
      [ENTITY_GROUP_CODE.PURCHASE_PROPOSAL_FORM]: [
        PERMISSION_VALUE.READ,
        PERMISSION_VALUE.CREATE,
        PERMISSION_VALUE.UPDATE,
      ],
      [ENTITY_GROUP_CODE.PHIEU_LUAN_CHUYEN]: [
        PERMISSION_VALUE.READ,
        PERMISSION_VALUE.CREATE,
        PERMISSION_VALUE.UPDATE,
      ],
    },
    childrens: [
      Solution.Quantitative.path,
      Solution.List.path,
      Solution.Create.path,
      Solution.Update.path,
      Solution.Print.path,
      Solution.Transfer.path,
      Solution.TransferCreate.path,
    ],
    _children: [
      {
        _tag: "CSidebarNavItem",
        name: Solution.Quantitative.name,
        to: Solution.Quantitative.path,
        childrens: [Solution.Quantitative.path],
        permissions: {
          [ENTITY_GROUP_CODE.PURCHASE_PROPOSAL_FORM]: PERMISSION_VALUE.READ,
        },
      },
      {
        _tag: "CSidebarNavItem",
        name: Solution.List.name,
        to: Solution.List.path,
        childrens: [Solution.List.path],
        permissions: {
          [ENTITY_GROUP_CODE.PURCHASE_PROPOSAL_FORM]: PERMISSION_VALUE.READ,
        },
      },
      {
        _tag: "CSidebarNavItem",
        name: Solution.Create.name,
        to: Solution.Create.path,
        childrens: [Solution.Create.path, Solution.Update.path],
        permissions: {
          [ENTITY_GROUP_CODE.PURCHASE_PROPOSAL_FORM]: [
            PERMISSION_VALUE.CREATE,
            PERMISSION_VALUE.UPDATE,
          ],
        },
      },
      {
        _tag: "CSidebarNavItem",
        name: Solution.Print.name,
        to: Solution.Print.path,
        childrens: [Solution.Print.path],
        permissions: {
          [ENTITY_GROUP_CODE.PURCHASE_PROPOSAL_FORM]: PERMISSION_VALUE.READ,
        },
      },
      {
        _tag: "CSidebarNavItem",
        name: Solution.Transfer.name,
        to: Solution.Transfer.path,
        childrens: [Solution.Transfer.path],
        permissions: {
          [ENTITY_GROUP_CODE.PHIEU_LUAN_CHUYEN]: PERMISSION_VALUE.READ,
        },
      },
      {
        _tag: "CSidebarNavItem",
        name: Solution.TransferCreate.name,
        to: Solution.TransferCreate.path,
        childrens: [Solution.TransferCreate.path],
        permissions: {
          [ENTITY_GROUP_CODE.PHIEU_LUAN_CHUYEN]: [
            PERMISSION_VALUE.CREATE,
            PERMISSION_VALUE.UPDATE,
          ],
        },
      },
    ],
  },
  //#endregion

  //#region Xuất hàng kho chi nhánh
  {
    _tag: "CSidebarNavDropdown",
    name: "Xuất hàng KCN",
    route: "/export",
    icon: <ExportIcon className="" />,
    permissions: {
      [ENTITY_GROUP_CODE.EXPORT_SLIP]: PERMISSION_VALUE.READ,
    },
    childrens: [
      Export.List.path,
      Export.Create.path,
      Export.Update.path,
      Export.Print.path,
    ],
    _children: [
      {
        _tag: "CSidebarNavItem",
        name: Export.List.name,
        to: Export.List.path,
        childrens: [Export.List.path, Export.Create.path, Export.Update.path],
        permissions: {
          [ENTITY_GROUP_CODE.EXPORT_SLIP]: PERMISSION_VALUE.READ,
        },
      },
      {
        _tag: "CSidebarNavItem",
        name: Export.Print.name,
        to: Export.Print.path,
        childrens: [Export.Print.path],
        permissions: {
          [ENTITY_GROUP_CODE.EXPORT_SLIP]: PERMISSION_VALUE.READ,
        },
      },
    ],
  },
  //#endregion

  //#region Xuất hàng kho trung tâm
  {
    _tag: "CSidebarNavDropdown",
    name: "Xuất hàng KTT",
    route: "/phieu-xuat-hang-ktt",
    icon: <ExportIcon className="" />,
    permissions: {
      [ENTITY_GROUP_CODE.EXPORT_SLIP]: PERMISSION_VALUE.READ,
    },
    childrens: [
      ExportKTT.List.path,
      ExportKTT.Create.path,
      ExportKTT.Update.path,
      ExportKTT.Print.path,
    ],
    _children: [
      {
        _tag: "CSidebarNavItem",
        name: ExportKTT.List.name,
        to: ExportKTT.List.path,
        childrens: [
          ExportKTT.List.path,
          ExportKTT.Create.path,
          ExportKTT.Update.path,
        ],
        permissions: {
          [ENTITY_GROUP_CODE.EXPORT_SLIP]: PERMISSION_VALUE.READ,
        },
      },
      {
        _tag: "CSidebarNavItem",
        name: ExportKTT.Print.name,
        to: ExportKTT.Print.path,
        childrens: [ExportKTT.Print.path],
        permissions: {
          [ENTITY_GROUP_CODE.EXPORT_SLIP]: PERMISSION_VALUE.READ,
        },
      },
    ],
  },
  //#endregion

  //#region Nhập hàng
  {
    _tag: "CSidebarNavDropdown",
    name: "Nhập hàng",
    route: "/import",
    icon: <ImportIcon className="" />,
    permissions: {
      [ENTITY_GROUP_CODE.PURCHASE_SLIP]: PERMISSION_VALUE.READ,
    },
    childrens: [
      Import.Material.List.path,
      Import.Material.Create.path,
      Import.Material.Update.path,
      Import.Material.Print.path,
      Import.OutsideMaterial.List.path,
      Import.OutsideMaterial.Create.path,
      Import.OutsideMaterial.Update.path,
    ],
    _children: [
      {
        _tag: "CSidebarNavItem",
        name: "DS Đơn nhập hàng",
        to: Import.Material.List.path,
        childrens: [
          Import.Material.List.path,
          Import.Material.Create.path,
          Import.Material.Update.path,
        ],
        permissions: {
          [ENTITY_GROUP_CODE.PURCHASE_SLIP]: PERMISSION_VALUE.READ,
        },
      },
      {
        _tag: "CSidebarNavItem",
        name: Import.Material.Print.name,
        to: Import.Material.Print.path,
        childrens: [Import.Material.Print.path],
        permissions: {
          [ENTITY_GROUP_CODE.PURCHASE_SLIP]: PERMISSION_VALUE.READ,
        },
      },
      {
        _tag: "CSidebarNavItem",
        name: "DS Đơn đặt hàng mua ngoài",
        to: Import.OutsideMaterial.List.path,
        childrens: [
          Import.OutsideMaterial.List.path,
          Import.OutsideMaterial.Create.path,
          Import.OutsideMaterial.Update.path,
        ],
        permissions: {
          [ENTITY_GROUP_CODE.PURCHASE_SLIP]: PERMISSION_VALUE.READ,
        },
      },
    ],
  },
  //#endregion

  //#region Nguyên vật liệu
  {
    _tag: "CSidebarNavDropdown",
    name: "Nguyên Vật Liệu",
    route: "/material",
    icon: <MaterialIcon className="" />,
    permissions: {
      [ENTITY_GROUP_CODE.MATERIAL]: PERMISSION_VALUE.READ,
      [ENTITY_GROUP_CODE.MATERIAL_GROUP]: PERMISSION_VALUE.READ,
      [ENTITY_GROUP_CODE.DE_XUAT_NGUYEN_VAT_LIEU]: PERMISSION_VALUE.READ,
    },
    childrens: [
      Material.Industry.path,
      Material.Category.path,
      Material.Type.path,
      Material.Suggest.path,
      Material.CreateMaterialSuggest.path,
      Material.UpdateMaterialSuggest.path,
      Material.List.path,
      Material.Update.path,
      Material.RawMaterial.path,
      Material.PriceUpdateReport.path,
      Material.SemiFinishedProduct.path,
      Material.PurchaseSemiFinishedProductsList.path,
    ],
    _children: [
      {
        _tag: "CSidebarNavItem",
        name: Material.Industry.name,
        to: Material.Industry.path,
        childrens: [Material.Industry.path],
        permissions: {
          [ENTITY_GROUP_CODE.MATERIAL]: PERMISSION_VALUE.READ,
        },
      },
      {
        _tag: "CSidebarNavItem",
        name: Material.Category.name,
        to: Material.Category.path,
        childrens: [Material.Category.path],
        permissions: {
          [ENTITY_GROUP_CODE.MATERIAL_GROUP]: PERMISSION_VALUE.READ,
        },
      },
      {
        _tag: "CSidebarNavItem",
        name: Material.Type.name,
        to: Material.Type.path,
        childrens: [Material.Type.path],
        permissions: {
          [ENTITY_GROUP_CODE.MATERIAL]: PERMISSION_VALUE.READ,
        },
      },
      {
        _tag: "CSidebarNavItem",
        name: Material.Suggest.name,
        to: Material.Suggest.path,
        childrens: [Material.Suggest.path],
        permissions: {
          [ENTITY_GROUP_CODE.DE_XUAT_NGUYEN_VAT_LIEU]: PERMISSION_VALUE.READ,
        },
      },
      {
        _tag: "CSidebarNavItem",
        name: Material.List.name,
        to: Material.List.path,
        childrens: [Material.List.path],
        permissions: {
          [ENTITY_GROUP_CODE.MATERIAL]: PERMISSION_VALUE.READ,
        },
      },
      {
        _tag: "CSidebarNavItem",
        name: Material.RawMaterial.name,
        to: Material.RawMaterial.path,
        childrens: [Material.RawMaterial.path],
        permissions: {
          [ENTITY_GROUP_CODE.MATERIAL]: PERMISSION_VALUE.READ,
        },
      },
      // {
      //   _tag: "CSidebarNavItem",
      //   name: Material.SemiFinishedProduct.name,
      //   to: Material.SemiFinishedProduct.path,
      //   childrens: [Material.SemiFinishedProduct.path],
      //   permissions: {
      //     [ENTITY_GROUP_CODE.MATERIAL]: PERMISSION_VALUE.READ,
      //   },
      // },
      {
        _tag: "CSidebarNavItem",
        name: Material.PurchaseSemiFinishedProductsList.name,
        to: Material.PurchaseSemiFinishedProductsList.path,
        childrens: [Material.PurchaseSemiFinishedProductsList.path],
        permissions: {
          [ENTITY_GROUP_CODE.MATERIAL]: PERMISSION_VALUE.READ,
        },
      },
    ],
  },
  //#endregion

  //#region Hàng hóa
  {
    _tag: "CSidebarNavDropdown",
    name: "Hàng Hóa",
    route: "/goods",
    icon: <GoodsBoxIcon className="icon-24" />,
    permissions: {
      [ENTITY_GROUP_CODE.HANG_HOA]: [
        PERMISSION_VALUE.READ,
        PERMISSION_VALUE.CREATE,
        PERMISSION_VALUE.UPDATE,
      ],
    },
    childrens: [
      HangHoa.Industry.path,
      HangHoa.Group.path,
      HangHoa.DeXuatMatHang.path,
      HangHoa.MatHang.path,
      HangHoa.CreateDanhMucHangHoa.path,
    ],
    _children: [
      {
        _tag: "CSidebarNavItem",
        name: HangHoa.Industry.name,
        to: HangHoa.Industry.path,
        childrens: [HangHoa.Industry.path],
        permissions: {
          [ENTITY_GROUP_CODE.HANG_HOA]: PERMISSION_VALUE.READ,
        },
      },
      {
        _tag: "CSidebarNavItem",
        name: HangHoa.Group.name,
        to: HangHoa.Group.path,
        childrens: [HangHoa.Group.path],
        permissions: {
          [ENTITY_GROUP_CODE.HANG_HOA]: PERMISSION_VALUE.READ,
        },
      },
      {
        _tag: "CSidebarNavItem",
        name: HangHoa.DeXuatMatHang.name,
        to: HangHoa.DeXuatMatHang.path,
        childrens: [HangHoa.DeXuatMatHang.path],
        permissions: {
          [ENTITY_GROUP_CODE.HANG_HOA]: PERMISSION_VALUE.READ,
        },
      },
      {
        _tag: "CSidebarNavItem",
        name: HangHoa.MatHang.name,
        to: HangHoa.MatHang.path,
        childrens: [HangHoa.MatHang.path],
        permissions: {
          [ENTITY_GROUP_CODE.HANG_HOA]: PERMISSION_VALUE.READ,
        },
      },
      {
        _tag: "CSidebarNavItem",
        name: HangHoa.CreateDanhMucHangHoa.name,
        to: HangHoa.CreateDanhMucHangHoa.path,
        childrens: [HangHoa.CreateDanhMucHangHoa.path],
        permissions: {
          [ENTITY_GROUP_CODE.HANG_HOA]: PERMISSION_VALUE.CREATE,
        },
      },
    ],
  },
  //#endregion

  //#region Menu
  {
    _tag: "CSidebarNavDropdown",
    name: "Menu",
    route: "/menus",
    icon: <MenuIcon className="icon-24" />,
    permissions: {
      [ENTITY_GROUP_CODE.MENU]: [
        PERMISSION_VALUE.READ,
        PERMISSION_VALUE.UPDATE,
      ],
    },
    childrens: [
      Menu.DanhSachMenu.path,
      Menu.TaoMenu.path,
      Menu.SuaMenu.path,
      Menu.DanhSachYeuCauDieuChinhGia.path,
    ],
    _children: [
      {
        _tag: "CSidebarNavItem",
        name: Menu.DanhSachMenu.name,
        to: Menu.DanhSachMenu.path,
        childrens: [Menu.DanhSachMenu.path],
        permissions: {
          [ENTITY_GROUP_CODE.MENU]: PERMISSION_VALUE.READ,
        },
      },
      {
        _tag: "CSidebarNavItem",
        name: Menu.DanhSachYeuCauDieuChinhGia.name,
        to: Menu.DanhSachYeuCauDieuChinhGia.path,
        childrens: [Menu.DanhSachYeuCauDieuChinhGia.path],
        permissions: {
          [ENTITY_GROUP_CODE.MENU]: PERMISSION_VALUE.UPDATE,
        },
      },
    ],
  },
  //#endregion

  //#region Phân quyền
  {
    _tag: "CSidebarNavDropdown",
    name: "Phân quyền",
    route: "/permission",
    icon: <PermissionIcon className="" />,
    permissions: {
      [ENTITY_GROUP_CODE.ROLE]: PERMISSION_VALUE.READ,
      [ENTITY_GROUP_CODE.CONFIGURATION]: PERMISSION_VALUE.READ,
      [ENTITY_GROUP_CODE.CAU_HINH_XUAT_NVL]: PERMISSION_VALUE.READ,
    },
    childrens: [
      Permission.Group.path,
      Permission.Slip.path,
      Permission.Configuration.path,
      Permission.ExportedMaterialConfig.path,
    ],
    _children: [
      {
        _tag: "CSidebarNavItem",
        name: Permission.Group.name,
        to: Permission.Group.path,
        childrens: [Permission.Group.path],
        permissions: {
          [ENTITY_GROUP_CODE.ROLE]: PERMISSION_VALUE.READ,
        },
      },
      {
        _tag: "CSidebarNavItem",
        name: Permission.Slip.name,
        to: Permission.Slip.path,
        childrens: [Permission.Slip.path],
        permissions: {
          [ENTITY_GROUP_CODE.ROLE]: PERMISSION_VALUE.READ,
        },
      },
      {
        _tag: "CSidebarNavItem",
        name: Permission.Configuration.name,
        to: Permission.Configuration.path,
        childrens: [Permission.Configuration.path],
        permissions: {
          [ENTITY_GROUP_CODE.CONFIGURATION]: PERMISSION_VALUE.READ,
        },
      },
      {
        _tag: "CSidebarNavItem",
        name: Permission.ApprovalConfiguration.name,
        to: Permission.ApprovalConfiguration.path,
        childrens: [Permission.ApprovalConfiguration.path],
        permissions: {
          [ENTITY_GROUP_CODE.CONFIGURATION]: PERMISSION_VALUE.READ,
        },
      },
      {
        _tag: "CSidebarNavItem",
        name: Permission.ExportedMaterialConfig.name,
        to: Permission.ExportedMaterialConfig.path,
        childrens: [Permission.ExportedMaterialConfig.path],
        permissions: {
          [ENTITY_GROUP_CODE.CAU_HINH_XUAT_NVL]: PERMISSION_VALUE.READ,
        },
      },
    ],
  },
  //#endregion

  //#region Nhà cung cấp
  {
    _tag: "CSidebarNavDropdown",
    name: "Nhà cung cấp",
    route: "/supplier",
    icon: <SupplierIcon className="icon-24" />,
    childrens: [
      DeXuatNhaCungCap.DanhSachDeXuatNhaCungCap.path,
      DeXuatNhaCungCap.PhieuDeXuatNhaCungCap.path,
      NhaCungCap.DanhSachPhieuChamDiemNhaCungCap.path,
      NhaCungCap.ThemPhieuChamDiemNhaCungCap.path,
      NhaCungCap.DanhSachNhaCungCap.path,
    ],
    _children: [
      {
        _tag: "CSidebarNavItem",
        name: DeXuatNhaCungCap.DanhSachDeXuatNhaCungCap.name,
        to: DeXuatNhaCungCap.DanhSachDeXuatNhaCungCap.path,
        childrens: [DeXuatNhaCungCap.DanhSachDeXuatNhaCungCap.path],
      },
      {
        _tag: "CSidebarNavItem",
        name: DeXuatNhaCungCap.PhieuDeXuatNhaCungCap.name,
        to: DeXuatNhaCungCap.PhieuDeXuatNhaCungCap.path,
        childrens: [DeXuatNhaCungCap.PhieuDeXuatNhaCungCap.path],
      },
      {
        _tag: "CSidebarNavItem",
        name: NhaCungCap.DanhSachPhieuChamDiemNhaCungCap.name,
        to: NhaCungCap.DanhSachPhieuChamDiemNhaCungCap.path,
        childrens: [NhaCungCap.DanhSachPhieuChamDiemNhaCungCap.path],
      },
      {
        _tag: "CSidebarNavItem",
        name: NhaCungCap.ThemPhieuChamDiemNhaCungCap.name,
        to: NhaCungCap.ThemPhieuChamDiemNhaCungCap.path,
        childrens: [NhaCungCap.ThemPhieuChamDiemNhaCungCap.path],
      },
      {
        _tag: "CSidebarNavItem",
        name: NhaCungCap.DanhSachNhaCungCap.name,
        to: NhaCungCap.DanhSachNhaCungCap.path,
        childrens: [NhaCungCap.DanhSachNhaCungCap.path],
      },
    ],
  },
  //#endregion

  //#region Chất lượng hàng hóa
  {
    _tag: "CSidebarNavDropdown",
    name: "Chất lượng hàng hóa",
    route: "/quality-of-goods",
    icon: <GoodsIcon className="icon-24" />,
    permissions: {
      [ENTITY_GROUP_CODE.HANG_HOA]: PERMISSION_VALUE.READ,
    },
    childrens: [
      ChatLuongHangHoa.DanhSachPhieuChamDiemHangHoa.path,
      ChatLuongHangHoa.ThemPhieuChamDiemHangHoa.path,
    ],
    _children: [
      {
        _tag: "CSidebarNavItem",
        name: ChatLuongHangHoa.DanhSachPhieuChamDiemHangHoa.name,
        to: ChatLuongHangHoa.DanhSachPhieuChamDiemHangHoa.path,
        childrens: [ChatLuongHangHoa.DanhSachPhieuChamDiemHangHoa.path],
        permissions: {
          [ENTITY_GROUP_CODE.HANG_HOA]: PERMISSION_VALUE.READ,
        },
      },
      {
        _tag: "CSidebarNavItem",
        name: ChatLuongHangHoa.ThemPhieuChamDiemHangHoa.name,
        to: ChatLuongHangHoa.ThemPhieuChamDiemHangHoa.path,
        childrens: [ChatLuongHangHoa.ThemPhieuChamDiemHangHoa.path],
        permissions: {
          [ENTITY_GROUP_CODE.HANG_HOA]: PERMISSION_VALUE.READ,
        },
      },
    ],
  },
  //#endregion

  //#region Combo
  {
    _tag: "CSidebarNavDropdown",
    name: "Combo",
    route: "/combos",
    icon: <ComboIcon className="icon-24" />,
    permissions: {
      [ENTITY_GROUP_CODE.COMBO]: PERMISSION_VALUE.READ,
      [ENTITY_GROUP_CODE.DE_XUAT_COMBO]: [
        PERMISSION_VALUE.READ,
        PERMISSION_VALUE.CREATE,
      ],
      [ENTITY_GROUP_CODE.COMBO_ITEM]: PERMISSION_VALUE.READ,
    },
    childrens: [
      Combo.DanhMucComboItem.path,
      Combo.ThemDeXuatCombo.path,
      Combo.DanhSachDeXuatCombo.path,
      Combo.DanhSachCombo.path,
    ],
    _children: [
      {
        _tag: "CSidebarNavItem",
        name: Combo.DanhMucComboItem.name,
        to: Combo.DanhMucComboItem.path,
        childrens: [Combo.DanhMucComboItem.path],
        permissions: {
          [ENTITY_GROUP_CODE.COMBO_ITEM]: PERMISSION_VALUE.READ,
        },
      },
      {
        _tag: "CSidebarNavItem",
        name: Combo.ThemDeXuatCombo.name,
        to: Combo.ThemDeXuatCombo.path,
        childrens: [Combo.ThemDeXuatCombo.path],
        permissions: {
          [ENTITY_GROUP_CODE.DE_XUAT_COMBO]: [
            PERMISSION_VALUE.CREATE,
            PERMISSION_VALUE.UPDATE,
          ],
        },
      },
      {
        _tag: "CSidebarNavItem",
        name: Combo.DanhSachDeXuatCombo.name,
        to: Combo.DanhSachDeXuatCombo.path,
        childrens: [Combo.DanhSachDeXuatCombo.path],
        permissions: {
          [ENTITY_GROUP_CODE.DE_XUAT_COMBO]: PERMISSION_VALUE.READ,
        },
      },
      {
        _tag: "CSidebarNavItem",
        name: Combo.DanhSachCombo.name,
        to: Combo.DanhSachCombo.path,
        childrens: [Combo.DanhSachCombo.path],
        permissions: {
          [ENTITY_GROUP_CODE.COMBO]: PERMISSION_VALUE.READ,
        },
      },
    ],
  },
  //#endregion

  //#region Kho
  {
    _tag: "CSidebarNavDropdown",
    name: "Kho",
    route: "/warehouses",
    icon: <WarehouseIcon className="icon-24" />,
    permissions: {
      [ENTITY_GROUP_CODE.COMBO_ITEM]: PERMISSION_VALUE.READ,
    },
    childrens: [Warehouse.DanhSachKho.path],
    _children: [
      {
        _tag: "CSidebarNavItem",
        name: Warehouse.DanhSachKho.name,
        to: Warehouse.DanhSachKho.path,
        childrens: [Warehouse.DanhSachKho.path],
        permissions: {
          [ENTITY_GROUP_CODE.COMBO_ITEM]: PERMISSION_VALUE.READ,
        },
      },
    ],
  },
  //#endregion
];

export default navigation;
